jQuery(function($) {

  //Header Hights Vars
  var root_vars = document.querySelector(':root');
  var header_height = 50;
  if($('.main-header.fixed').length){
    header_height = $('.main-header.fixed').outerHeight();
    root_vars.style.setProperty('--header-height', header_height+'px');
  }

  if($('.js-highlight-bar').length){
    var height = $('.js-highlight-bar').outerHeight();
    header_height = header_height + height;
    root_vars.style.setProperty('--header-height', header_height+'px');
    root_vars.style.setProperty('--header-top-height', height+'px');
  }

  $('a[href^="#"]').on('click', function (e) {
    const targetId = $(this).attr('href');

    // skip if href is just "#"
    if (targetId.length <= 1) return;

    const $target = $(targetId);
    if ($target.length) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: $target.offset().top - header_height - 100
      }, 300, 'swing');
    }
  });

  $(".js-scroll-next-section").click(function(e) {
      e.preventDefault();
      var target;
      target = $(this).parents('section').nextAll('section');
      $('html, body').animate({
          scrollTop: $(target).offset().top - header_height
      });
      return false;
  });


  //Handles Navigation
  $('.menu-item-has-children').click(function(e){

    if ($(e.target).closest('.sub-menu').length) {
        return;
    }
    e.preventDefault();
    $('.sub-menu').not($(this).find('.sub-menu')).removeClass('active');
    $('.menu-item-has-children a').not($(this).find('a')).removeClass('active');
    $(this).find('.sub-menu').toggleClass('active');
    $(this).find('a').not('.sub-menu a').toggleClass('active');
  });

  $('.js-book-dropdown').click(function(e){
    e.preventDefault();
    $(this).parents('.book-modal-container').find('.book-modal').toggleClass('active');
  });

  $('.js-mobile-nav').click(function(e){
    e.preventDefault();
    $(this).parents('.main-nav').find('.main-menu').toggleClass('active');
  });
  $('.js-mobile-nav-close').click(function(e){
    e.preventDefault();
    $(this).parents('.main-nav').find('.main-menu').removeClass('active');
  });
  $('.js-mobile-booking-close').click(function(e){
    e.preventDefault();
    $(this).parents('.main-nav').find('.book-modal').removeClass('active');
  });

  //Footer Menu (Mobile)
  $('.footer-menu-title').click(function(e){
    e.preventDefault();
    $(this).parents('.footer-menu').toggleClass('active');
    $(this).parents('.footer-menu').find('.footer-menu-items').slideToggle(); 
    $('.footer-menu').not($(this).parents('.footer-menu')).removeClass('active');
    $('.footer-menu').not($(this).parents('.footer-menu')).find('.footer-menu-items').slideUp();
  });



  $('.js-media-carousel').each(function() {
    const $carousel = $(this);
    const $parent   = $carousel.parent(); 
    
    // Default effect
    let effect = 'fade';
    let extraOptions = {};
    let autoplay = false;
    let speed = 300;

    // Detect effect based on class
    if ($carousel.hasClass('autoplay')) {
      autoplay = {
        delay: 3000, // ms
        disableOnInteraction: false
      };
      if($carousel.hasClass('style-default')){
        speed = 3000;
      }else{
         speed = 600;
      }
    }
    if ($carousel.hasClass('style-slide')) {
      effect = 'slide';
    } 
    else if ($carousel.hasClass('style-flip')) {
      effect = 'flip';
    } 
    else if ($carousel.hasClass('style-cube')) {
      effect = 'cube';
    } 
    else if ($carousel.hasClass('style-cards')) {
      effect = 'cards';
    }

    // Add crossFade only for fade effect
    if (effect === 'fade') {
      extraOptions.fadeEffect = { crossFade: true };
    }

    // Initialize Swiper with dynamic effect
    new Swiper(this, {
      loop: true,
      autoplay: autoplay,
      speed: speed,
      effect: effect,
      ...extraOptions,
      pagination: {
        el: $parent.find('.swiper-dots')[0],
      },
      navigation: {
        nextEl: $parent.find('.js-img-next.swiper-control')[0],
        prevEl: $parent.find('.js-img-prev.swiper-control')[0],
      },
      scrollbar: {
        el: $parent.find('.swiper-scrollbar')[0],
      },
    });
  });
});


//In Page Nav
document.addEventListener("DOMContentLoaded", function () {
    const navBlocks = document.querySelectorAll(".inpage-nav");

    navBlocks.forEach(nav => {
        const container = nav.closest(".inpage-nav-container");
        if (!container){ return; }

        const sections = container.querySelectorAll(".row.container[id]");
        const navLinks = nav.querySelectorAll("a");

        // Map section ID → nav link
        const sectionMap = {};
        navLinks.forEach(link => {
            const targetId = link.getAttribute("href").replace("#", "");
            sectionMap[targetId] = link;
        });

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const id = entry.target.id;
                    // Remove active from all links in THIS nav only
                    navLinks.forEach(link => link.classList.remove("active"));
                    console.log(navLinks);
                    // Add active to the matching one
                    if (sectionMap[id]) {
                        sectionMap[id].classList.add("active");
                    }
                }
            });
        }, {
            root: null,
            rootMargin: "-50% 0px -50% 0px",
            threshold: 0
        });

        sections.forEach(section => observer.observe(section));
    });
});

console.log(
    "%cWebsite Development by Tom Buxton\n%c In House Theme: BedRock V1.0.0",
    "color: white; background: #000; font-size: 16px; font-weight: bold; padding: 6px 12px; border-radius: 4px 4px 0 0;",
    "color: #000; background: #f4d03f; font-size: 14px; padding: 4px 12px; border-radius: 0 0 4px 4px;"
);